import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SubscriptionLike as ISubscription } from 'rxjs';
import { AuthService } from '../../core/services/auth/auth.service';
import { UtilityService } from '../../core/services/utility/utility.service';
import { SharedService } from '../share-content/shared.service';
// import { FormArray } from '@angular/forms/src/model';
import { APP_SETTINGS } from '@services';
import { AnalyticsService } from '../../core/services/analytics/analytics.service';
import { NgFor, NgStyle, NgIf } from '@angular/common';

@Component({
    selector: 'app-noise-catalog-share-content',
    templateUrl: './noise-catalog-share-content.component.html',
    styleUrls: ['./noise-catalog-share-content.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        FormsModule,
        ReactiveFormsModule,
        NgFor,
        NgStyle,
        NgIf,
    ],
})
export class NoiseCatalogShareContentComponent implements OnInit, OnDestroy {
  @Input() noisecatalogshareContent: any;
  public userEmails: string[];
  username: string;
  public userForm = new UntypedFormGroup({});
  public body = new UntypedFormControl('');
  public email = new UntypedFormControl('', Validators.required);
  emails: any[] = [];
  private subscriptions: ISubscription[];
  private selectedBranch = ''; //ASENGG-29541 Share Links Brand Issue Fix
  
  makeName: string;
  noiseCatalogUrl: string;
  minEmailSender: number;
  APP_SETTINGS:any;
  constructor(
    private fb: UntypedFormBuilder,
    private authService: AuthService,
    private sharedService: SharedService,
    private analyticsService: AnalyticsService,
    private utilityService: UtilityService
  ) { }

  get formData() { return <UntypedFormArray>this.userForm.get('emails'); }

  ngOnInit() {
    this.APP_SETTINGS = APP_SETTINGS;
    this.minEmailSender = 1;
    this.subscriptions = [];
    this.username = this.authService.getUserName();
    this.userForm = this.fb.group({
      body: this.body,
      emails: this.fb.array([this.fb.group({
        email: new UntypedFormControl('', Validators.required)
      })])
    });
  }

  addNewEmail() {
    const control = <UntypedFormArray>this.userForm.controls.emails;
    this.minEmailSender
    control.push(
      this.fb.group({
        email: this.email
      })
    );
    this.minEmailSender = control.length;

  }

  removeNewEmail() {
    const control = <UntypedFormArray>this.userForm.controls.emails;
    if ((control.length - 1) > 0)
      control.removeAt(
        (control.length - 1)
      );
    this.minEmailSender = control.length;

  }

  onSubmit(form) {
    if (this.noisecatalogshareContent['type'] === 'noisecatalog') {
      //Analytics Call
      this.analyticsService.trackSharedContentByTypeLineMake('Noise Catalog', this.noisecatalogshareContent['noiseCatalogDisplayNumber'], 'shared');
    }
    this.utilityService.closeShareContentPopup(true);
    this.makeName = APP_SETTINGS.isBMW ? 'BMW' : 'MINI';
    let baseUrl = '';
    if (window.location.origin === 'https://tis-prod.aws.bmw.cloud') {
      baseUrl = 'https://fed.bmwgroup.com/pf/adapter2adapter.ping?IdpAdapterId=dcsnetot&SpSessionAuthnAdapterId=smsp&TargetResource=' + window.location.origin + window.location.pathname;
    } else if (window.location.origin === 'https://tis-int.aws.bmw.cloud') {
      if (APP_SETTINGS.isBMW == 'true') {
        baseUrl = 'https://fed-i.bmwgroup.com/pf/adapter2adapter.ping?IdpAdapterId=dcsnetot&SpSessionAuthnAdapterId=smps&TargetResource=' + window.location.origin + window.location.pathname;
      } else {
        baseUrl = 'https://fed-i.bmwgroup.com/pf/adapter2adapter.ping?IdpAdapterId=dcsnetot&SpSessionAuthnAdapterId=smps&TargetResource=' + window.location.origin + "/?linemake=MINI" + window.location.pathname;
      }
    } else {
      baseUrl = window.location.origin + window.location.pathname;
    }

    if (this.noisecatalogshareContent['type'] === 'noisecatalog') {
      this.noiseCatalogUrl =
        `/noisecatalogplayback?mainGroup=${this.noisecatalogshareContent['mainGroup']}&noisecatalog=${this.noisecatalogshareContent['noiseCatalogId']}&watchlist=false`;
    }
    form.value.emails.map(emailInfo => {
      if (emailInfo.email.trim() !== '') {
        this.emails.push(emailInfo.email);
      }
    });

    let emailBodyText = 'Message blank';
    if (this.body.value == null || this.body.value == undefined || this.body.value.length == 0) {
      emailBodyText = 'Message blank';
    } else {
      emailBodyText = this.body.value;
    }

    //ASENGG-29541 Share Links Brand Issue Fix
    if (APP_SETTINGS.isBMW === "true") {
      this.selectedBranch="BMW";  
    }
    if (APP_SETTINGS.isMINI === "true") {
      this.selectedBranch="MINI";
    }
    if (APP_SETTINGS.isMOTORRAD === "true") {
      this.selectedBranch="MOTORRAD";
    }
    if (APP_SETTINGS.isRollsRoyce === "true") {
      this.selectedBranch="ROLLSROYCE";
    }

    this.noisecatalogshareContent = {
      'emailBody': emailBodyText,
      'emailList': this.emails,
      'shareLinkURL': baseUrl + encodeURIComponent('#/' + this.noiseCatalogUrl),
      'make': this.selectedBranch //ASENGG-29541 Share Links Brand Issue Fix
    };

    this.subscriptions.push(this.sharedService.shareContent((this.noisecatalogshareContent)).subscribe(data => {
      this.emails = [];
    }, err => {
      this.emails = [];
    }));
  }
  ngOnDestroy(): void {
    this.subscriptions.map(s => s.unsubscribe());
  }

}
